module.exports = __webpack_public_path__ + "img/South-Korea.04acaa53.jpg";